module.exports = __webpack_public_path__ + "media/images/new_home/eatokra-iphone-mockup-b0f905f08a22b536648be87a90a1b0f0.png";